import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              最新文章
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">最新发布的优质内容</p>
          </div>
          <Link
            to="/category/tech"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer overflow-hidden"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium self-start mb-2">
                  {article.categoryName}
                </span>
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-auto pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}